export function createErrorClass(createImpl) {
    const _super = (instance) => {
        Error.call(instance);
        instance.name = instance.constructor.name;
        instance.stack = new Error().stack;
    };
    const ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}
//# sourceMappingURL=createErrorClass.js.map